import * as Yup from "yup";
import { NormalizedOriginProject } from "slices/originProjects/originProjectState";
import { WorkdayProjectType } from "app/ApiClient";

const REQUIRED_MESSAGE = "Field required";

export type WorkdayProjectForm = {
  name: string;
  workdayId: string;
  client?: string;
  costCenter?: string;
  workdayProjectType?: WorkdayProjectType;
};
export type ProjectFormData = {
  project?: NormalizedOriginProject | null;
  workdayProject?: WorkdayProjectForm;
};

export const originProjectFormData: ProjectFormData = {};
export const projectViewModelSchema = Yup.object({
  project: Yup.object()
    .nullable()
    .required("*Dataset is a required field"),

  workdayProject: Yup.object({
    name: Yup.string().required(REQUIRED_MESSAGE),
    workdayId: Yup.string().required(REQUIRED_MESSAGE),

    workdayProjectType: Yup.mixed<WorkdayProjectType>()
      .oneOf(Object.values(WorkdayProjectType))
      .required(REQUIRED_MESSAGE),

    client: Yup.string().nullable(),
    costCenter: Yup.string().nullable(),
  }).required(),
});
